// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"styles_pageWrapper__1sA46","layout":"styles_layout__1ysbd"};